import PratusSelect, {
  PratusSelectProps,
  type OptionType,
} from 'components/DesignSystems/New/PratusSelect';
import { useAllIncidents } from 'components/IAP/hooks/incidentHooks';

type IncidentSelectProps = Omit<
  PratusSelectProps,
  'options' | 'value' | 'onChange'
> & {
  label?: string;
  value: string | null;
  onChange: (value: string | null) => void;
};

export function IncidentSelect({
  label = 'Incident',
  value,
  onChange,
  classes,
  isDisabled,
  isClearable,
}: IncidentSelectProps) {
  const { data: incidents = [] } = useAllIncidents();

  const options = incidents.map((i) => ({
    value: i.id,
    label: i.name,
  }));

  const selectedOption =
    options.find((opt) => opt.value === value) ?? undefined;

  return (
    <PratusSelect
      label={label}
      options={options}
      value={selectedOption}
      onChange={(val) => {
        if (!val) {
          onChange(null);
          return;
        }

        const option = val as OptionType;
        onChange(String(option.value));
      }}
      classes={classes}
      isDisabled={isDisabled}
      isClearable={isClearable}
    />
  );
}
